import { createUrl } from "@mne-core/api";

export const transformUrlOpenApi = (apiUrl: string, module: string) =>
  createUrl(apiUrl, [module, "/openapi.json"]).toString();
